
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services",
      function () {
        return require("private-next-pages/services/index.js");
      }
    ]);
  